import { render, staticRenderFns } from "./RefuseSolution.vue?vue&type=template&id=2717edc9&scoped=true"
import script from "./RefuseSolution.vue?vue&type=script&lang=js"
export * from "./RefuseSolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717edc9",
  null
  
)

export default component.exports